const logotiposUrl = `${process.env.REACT_APP_URL_ASSETS}/logotipos/1.0.0/creditas`;

export const primaryLogo = `${logotiposUrl}/primary_logo.svg`;
